export default __webpack_public_path__ + "static/city-device-cover-058a9b7b20910ea59461671477942106.webp";